// src/components/PickFilters.jsx
// Type-ahead filters over rows already loaded (3.18.8: Control Panel →
// Security). Each field suggests its values as you type and several can be
// picked; picks in different fields must all match. Each field only
// suggests values found in the rows the other fields leave (pick a sender,
// and Reason lists only that sender's reasons).
//   const pf = usePickFilters(rows, [{ key, label, get, placeholder }]);
//   <PickFilters state={pf} groupStyle labelStyle />   pf.filtered, pf.reset()
import { useMemo, useState } from 'react';
import MultiSearchSelect from './MultiSearchSelect';

export function usePickFilters(rows, fields) {
  const [picks, setPicks] = useState({});
  const val = (f, r) => String(f.get(r) ?? '');
  const passes = (r, except) => fields.every(f => {
    const p = picks[f.key] || [];
    if (f.key === except || !p.length) return true;
    const v = val(f, r).toLowerCase();
    return p.some(x => v.includes(String(x).toLowerCase()));
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const filtered = useMemo(() => rows.filter(r => passes(r, null)), [rows, picks]);
  const optionsFor = key => {
    const f = fields.find(x => x.key === key);
    return [...new Set(rows.filter(r => passes(r, key)).map(r => val(f, r)).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  };
  return {
    fields, picks, filtered, optionsFor,
    setPick: (key, v) => setPicks(p => ({ ...p, [key]: v })),
    reset: () => setPicks({}),
    active: Object.values(picks).some(v => v?.length),
  };
}

export default function PickFilters({ state, groupStyle, labelStyle }) {
  return state.fields.map(f => (
    <div key={f.key} style={{ ...groupStyle, minWidth: 220 }}>
      <label style={labelStyle}>{f.label}</label>
      <MultiSearchSelect values={state.picks[f.key] || []} onChange={v => state.setPick(f.key, v)}
        options={state.optionsFor(f.key)} placeholder={f.placeholder || `Type to find a ${f.label.toLowerCase()}`} />
    </div>
  ));
}
